export default {"src":"https://images-cdn.curipod.com/d-8f01cb86/_next/static/media/gwinnett_county.1b5c2fe8.svg","height":86,"width":267};